import axios from "axios";
import axiosInstance from "../../api/axiosInstance";
import { app } from "../../api";

const apiUrl = app;

// Authenticated endpoints use axiosInstance
export function loadAcademic(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/accademic/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadAcademicActive() {
  return axiosInstance.get(`${apiUrl}/accademic/active`);
}

export function loadAcademicByid(id) {
  return axiosInstance.get(`${apiUrl}/accademic/list?id=${id}`);
}

export function addAcademic() {
  return axiosInstance.post(`${apiUrl}/accademic`);
}

export function loadSemister(pageLimit, page, academic, search, order) {
  return axiosInstance.get(
    `${apiUrl}/semister/list?limit=${pageLimit}&offset=${page}&accademic__id__in=${academic}&search=${search}&ordering=${order}`
  );
}

export function loadSemisterActive(academic) {
  return axiosInstance.get(`${apiUrl}/semister/active/${academic}`);
}

export function addSemister(academic) {
  return axiosInstance.post(`${apiUrl}/semister/${academic}`);
}

export function loadCampas(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/cumpas/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function addCampas() {
  return axiosInstance.post(`${apiUrl}/cumpas`);
}

// Building
export function loadBuilding(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/building/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadBuildingByCampus(campusId) {
  return axiosInstance.get(`${apiUrl}/building/campus/${campusId}`);
}

export function addBuilding(data) {
  return axiosInstance.post(`${apiUrl}/building`, data);
}

export function updateBuilding(id, data) {
  return axiosInstance.put(`${apiUrl}/building/${id}`, data);
}

export function deleteBuilding(id) {
  return axiosInstance.delete(`${apiUrl}/building/${id}`);
}

// Venue Type
export function loadVenueType(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/venue-type/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadVenueTypeActive() {
  return axiosInstance.get(`${apiUrl}/venue-type/active`);
}

export function addVenueType(data) {
  return axiosInstance.post(`${apiUrl}/venue-type`, data);
}

export function updateVenueType(id, data) {
  return axiosInstance.put(`${apiUrl}/venue-type/${id}`, data);
}

export function deleteVenueType(id) {
  return axiosInstance.delete(`${apiUrl}/venue-type/${id}`);
}

// Room/Venue
export function loadRoom(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/room/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadRoomFilter(pageLimit, page, campusId, buildingId, venueTypeId, roomType, search, order) {
  let url = `${apiUrl}/room/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`;
  if (campusId) url += `&cumpas__id__in=${campusId}`;
  if (buildingId) url += `&building__id__in=${buildingId}`;
  if (venueTypeId) url += `&venue_type__id__in=${venueTypeId}`;
  if (roomType) url += `&room_type__in=${roomType}`;
  return axiosInstance.get(url);
}

export function loadRoomByBuilding(buildingId) {
  return axiosInstance.get(`${apiUrl}/room/building/${buildingId}`);
}

export function loadRoomByCampus(campusId) {
  return axiosInstance.get(`${apiUrl}/room/campus/${campusId}`);
}

export function loadRoomAvailable(campusId, buildingId, roomType, minCapacity) {
  let url = `${apiUrl}/room/available?`;
  if (campusId) url += `campus=${campusId}&`;
  if (buildingId) url += `building=${buildingId}&`;
  if (roomType) url += `type=${roomType}&`;
  if (minCapacity) url += `min_capacity=${minCapacity}`;
  return axiosInstance.get(url);
}

export function addRoom(data) {
  return axiosInstance.post(`${apiUrl}/room/create`, data);
}

export function updateRoom(id, data) {
  return axiosInstance.put(`${apiUrl}/room/${id}`, data);
}

export function deleteRoom(id) {
  return axiosInstance.delete(`${apiUrl}/room/${id}`);
}

export function loadSchool(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/school/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function addSchool() {
  return axiosInstance.post(`${apiUrl}/school`);
}

export function loadSchoolById(id) {
  return axiosInstance.get(`${apiUrl}/school/list?id=${id}`);
}

export function loadDepartment(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/department/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function addDepartment() {
  return axiosInstance.post(`${apiUrl}/department`);
}

export function loadDepartmentById(id) {
  return axiosInstance.get(`${apiUrl}/department/list?id=${id}`);
}

export function loadProgramme(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/programme/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function addProgramme() {
  return axiosInstance.post(`${apiUrl}/programme`);
}

export function loadProgrammeById(id) {
  return axiosInstance.get(`${apiUrl}/programme/list?id=${id}`);
}

export function loadEnrollment(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/enrollment/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadEnrollmentFilter(
  pageLimit,
  page,
  id,
  campas,
  academic,
  semister,
  active,
  search,
  order
) {
  return axiosInstance.get(
    `${apiUrl}/enrollment/list?limit=${pageLimit}&offset=${page}&id__in=${id}&cumpas__id__in=${campas}&academic__id__in=${academic}
    &semister__id__in=${semister}&is_active=${active}&search=${search}&ordering=${order}`
  );
}

export function addEnrollment(data) {
  return axiosInstance.post(`${apiUrl}/enrollment`, data);
}

export function loadEnrollmentItem(enrollId) {
  return axiosInstance.get(
    `${apiUrl}/enrollment-item/list?enroll__id__in=${enrollId}&limit=500`
  );
}

export function loadEnrollmentItemByCourse(enroll, course) {
  return axiosInstance.get(
    `${apiUrl}/enrollment-item/list?enroll__id__in=${enroll}&course__in=${course}`
  );
}

export function loadEnrolledCourse() {
  return axiosInstance.get(`${apiUrl}/enrollment-item/course`);
}



export function loadTimeTable(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/time-table/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function loadTimeTableFilter(
  pageLimit,
  page,
  id,
  campas,
  academic,
  semister,
  active,
  approve,
  publish,
  search,
  order
) {
  return axiosInstance.get(
    `${apiUrl}/time-table/list?limit=${pageLimit}&offset=${page}&id__in=${id}&cumpas__id__in=${campas}&academic__id__in=${academic}
    &semister__id__in=${semister}&is_active=${active}&is_published=${publish}&is_approved=${approve}&search=${search}&ordering=${order}`
  );
}

export function addTimeTable(data) {
  return axiosInstance.post(`${apiUrl}/time-table`, data);
}

export function loadTableDayByTable(table) {
  return axiosInstance.get(`${apiUrl}/time-day/list?table__id__in=${table}`);
}

export function loadTableDayByRoom(room) {
 return axiosInstance.get(`${apiUrl}/time-day/list?room__id__in=${room}`);
}

export function loadTableDayBySchool(school) {
 return axiosInstance.get(`${apiUrl}/time-day/list?school__id__in=${school}`);
}

export function loadTableDayByDepartment(department) {
 return axiosInstance.get(`${apiUrl}/time-day/list?department__id__in=${department}`);
}

export function loadTableDayByPrgramme(programme) {
 return axiosInstance.get(`${apiUrl}/time-day/list?programme__id__in=${programme}`);
}

export function loadTableDayByCourse(course) {
 return axiosInstance.get(`${apiUrl}/time-day/list?enrollment__course__in=${course}`);
}

export function loadTableDayByDay(table, day) {
  return axiosInstance.get(
    `${apiUrl}/time-day/list?table__id__in=${table}&day__in=${day}`
  );
}

export function loadTableDayByInstractor(instractor) {
  return axiosInstance.get(`${apiUrl}/time-day/list?instractor__in=${instractor}`);
}

// Manual adjustment functions
export function updateTableDay(id, data) {
  return axiosInstance.put(`${apiUrl}/time-day/${id}`, data);
}

export function deleteTableDay(id) {
  return axiosInstance.delete(`${apiUrl}/time-day/${id}/delete`);
}

export function createTableDay(data) {
  return axiosInstance.post(`${apiUrl}/time-day/create`, data);
}

export function checkConflict(data) {
  return axiosInstance.post(`${apiUrl}/time-day/conflict-check`, data);
}

// Timetable generation
export function generateTimeTable(tableId) {
  return axiosInstance.post(`${apiUrl}/time-table/${tableId}/generate`);
}

export function loadTimetableConflicts(tableId) {
  return axiosInstance.get(`${apiUrl}/time-table/${tableId}/conflicts`);
}

// Export functions - return URLs for direct download
export function getExportPDFUrl(tableId) {
  return `${apiUrl}/time-table/${tableId}/export/pdf`;
}

export function getExportExcelUrl(tableId) {
  return `${apiUrl}/time-table/${tableId}/export/excel`;
}

export function getExportICalUrl(tableId) {
  return `${apiUrl}/time-table/${tableId}/export/ical`;
}

// Authenticated download functions
async function downloadWithAuth(url, filename) {
  const response = await axiosInstance.get(url, { responseType: "blob" });
  const blob = new Blob([response.data]);
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
}

export function downloadTimetablePDF(tableId) {
  return downloadWithAuth(getExportPDFUrl(tableId), `timetable_${tableId}.pdf`);
}

export function downloadTimetableExcel(tableId) {
  return downloadWithAuth(getExportExcelUrl(tableId), `timetable_${tableId}.xlsx`);
}

export function downloadTimetableICal(tableId) {
  return downloadWithAuth(getExportICalUrl(tableId), `timetable_${tableId}.ics`);
}

// Instructor Preferences
export function loadInstructorPreferences(pageLimit, page, instructorId, academicId, semesterId) {
  let url = `${apiUrl}/instructor-preference/list?limit=${pageLimit}&offset=${page}`;
  if (instructorId) url += `&instractor__id=${instructorId}`;
  if (academicId) url += `&academic__id=${academicId}`;
  if (semesterId) url += `&semister__id=${semesterId}`;
  return axiosInstance.get(url);
}

export function addInstructorPreference(data) {
  return axiosInstance.post(`${apiUrl}/instructor-preference`, data);
}

export function updateInstructorPreference(id, data) {
  return axiosInstance.put(`${apiUrl}/instructor-preference/${id}`, data);
}

export function deleteInstructorPreference(id) {
  return axiosInstance.delete(`${apiUrl}/instructor-preference/${id}/delete`);
}

// Room Constraints
export function loadRoomConstraints(pageLimit, page, roomId, constraintType, applyTo, programmeId, buildingId) {
  let url = `${apiUrl}/room-constraint/list?limit=${pageLimit}&offset=${page}`;
  if (roomId) url += `&room__id__in=${roomId}`;
  if (constraintType) url += `&constraint_type=${constraintType}`;
  if (applyTo) url += `&apply_to=${applyTo}`;
  if (programmeId) url += `&programme__id__in=${programmeId}`;
  if (buildingId) url += `&building__id__in=${buildingId}`;
  return axiosInstance.get(url);
}

export function addRoomConstraint(data) {
  return axiosInstance.post(`${apiUrl}/room-constraint`, data);
}

export function addRoomConstraintsBulk(constraints) {
  return axiosInstance.post(`${apiUrl}/room-constraint/bulk`, { constraints });
}

export function updateRoomConstraint(id, data) {
  return axiosInstance.put(`${apiUrl}/room-constraint/${id}`, data);
}

export function deleteRoomConstraint(id) {
  return axiosInstance.delete(`${apiUrl}/room-constraint/${id}/delete`);
}

// Exam Timetable
export function loadExamTimetable(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/exam-timetable/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function addExamTimetable(data) {
  return axiosInstance.post(`${apiUrl}/exam-timetable`, data);
}

export function generateExamTimetable(examId) {
  return axiosInstance.post(`${apiUrl}/exam-timetable/${examId}/generate`);
}

// Exam Sessions
export function loadExamSession(examTimetableId) {
  return axiosInstance.get(`${apiUrl}/exam-session/list?exam_timetable__id=${examTimetableId}`);
}

export function loadExamSessions(examTimetableId, programmeId, studyYear, examDate) {
  let url = `${apiUrl}/exam-session/list?exam_timetable__id=${examTimetableId}`;
  if (programmeId) url += `&programme__id=${programmeId}`;
  if (studyYear) url += `&study_year=${studyYear}`;
  if (examDate) url += `&exam_date=${examDate}`;
  return axiosInstance.get(url);
}

export function updateExamSession(id, data) {
  return axiosInstance.put(`${apiUrl}/exam-session/${id}`, data);
}

// Exam Timetable Export URLs
export function getExamExportPDFUrl(examId) {
  return `${apiUrl}/exam-timetable/${examId}/export/pdf`;
}

export function getExamExportExcelUrl(examId) {
  return `${apiUrl}/exam-timetable/${examId}/export/excel`;
}

// Public API (no auth required)
export function loadPublicTimetable(params = {}) {
  const { campus, academic, semester, programme, year, day, instructor } = params;
  let url = `${apiUrl}/public/timetable?`;
  if (campus) url += `campus=${campus}&`;
  if (academic) url += `academic=${academic}&`;
  if (semester) url += `semester=${semester}&`;
  if (programme) url += `programme=${programme}&`;
  if (year) url += `year=${year}&`;
  if (day) url += `day=${day}&`;
  if (instructor) url += `instructor=${instructor}`;
  return axios.get(url);
}

export function loadPublicExam(params = {}) {
  const { campus, academic, semester, programme, year } = params;
  let url = `${apiUrl}/public/exam?`;
  if (campus) url += `campus=${campus}&`;
  if (academic) url += `academic=${academic}&`;
  if (semester) url += `semester=${semester}&`;
  if (programme) url += `programme=${programme}&`;
  if (year) url += `year=${year}`;
  return axios.get(url);
}

export function loadPublicProgrammes() {
  return axios.get(`${apiUrl}/public/programmes`);
}

export function loadPublicCampuses() {
  return axios.get(`${apiUrl}/public/campuses`);
}

export function loadPublicAcademicYears() {
  return axios.get(`${apiUrl}/public/academic-years`);
}

export function loadPublicSemesters(academicId) {
  let url = `${apiUrl}/public/semesters`;
  if (academicId) url += `?academic=${academicId}`;
  return axios.get(url);
}

export function loadPublicInstructors(campus, academic) {
  let url = `${apiUrl}/public/instructors?`;
  if (campus) url += `campus=${campus}&`;
  if (academic) url += `academic=${academic}`;
  return axios.get(url);
}




// Uploaded Timetables
export function loadUploadedTimetables(pageLimit, page, search, order) {
  return axiosInstance.get(
    `${apiUrl}/uploaded-timetable/list?limit=${pageLimit}&offset=${page}&search=${search}&ordering=${order}`
  );
}

export function uploadTimetable(formData) {
  return axiosInstance.post(`${apiUrl}/uploaded-timetable`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function deleteUploadedTimetable(id) {
  return axiosInstance.delete(`${apiUrl}/uploaded-timetable/${id}`);
}

export function updateUploadedTimetable(id, data) {
  return axiosInstance.put(`${apiUrl}/uploaded-timetable/${id}`, data);
}

export function getUploadedTimetableDownloadUrl(id) {
  return `${apiUrl}/uploaded-timetable/${id}/download`;
}

// Uploaded Timetable Entries
export function loadUploadedEntries(timetableId) {
  return axiosInstance.get(`${apiUrl}/uploaded-timetable/${timetableId}/entries`);
}

export function parseUploadedTimetable(timetableId) {
  return axiosInstance.post(`${apiUrl}/uploaded-timetable/${timetableId}/parse`);
}

export function updateUploadedEntry(entryId, data) {
  return axiosInstance.put(`${apiUrl}/uploaded-entry/${entryId}`, data);
}

export function deleteUploadedEntry(entryId) {
  return axiosInstance.delete(`${apiUrl}/uploaded-entry/${entryId}/delete`);
}

export function createUploadedEntry(data) {
  return axiosInstance.post(`${apiUrl}/uploaded-entry`, data);
}
